"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _operators = require("rxjs/operators");

var waitFor = function waitFor(wait$) {
  return (0, _operators.delayWhen)(function () {
    return wait$;
  });
};

var _default = waitFor;
exports["default"] = _default;